import React from 'react';
import classNames from 'classnames';

const CircularBadge = ({className, ...props}: React.HTMLProps<HTMLSpanElement>) => (
  <span className={classNames('CircularBadge', className)} {...props} />
);

export default CircularBadge;
